<div class="main-wrapper">
  <div class="content">
    <div class="form-container">
      <img
        src="assets/svg/logos/saude_conectada_logo.svg"
        alt="Logo Saúde Conectada"
        class="logo"
      />

      <div class="texts">
        <h2>Link expirado.</h2>
        <p>
          Solicite um novo código. Ele será enviado para o seu e-mail e
          permitirá que você continue o processo.
        </p>
      </div>

      <form class="form-fields">
        <button
          mat-raised-button
          color="primary"
          class="submit-button"
          type="submit"
          (click)="solicitarNovoLink()"
        >
          Solicitar novo link
        </button>
      </form>
      <div class="return" (click)="voltarParaLogin()">
        <img src="assets/svg/icons/arrow_left.svg" alt="" />
        <p>Voltar para login</p>
      </div>

      <img
        src="assets/svg/logos/sesi_logo.svg"
        alt="Logo SESI"
        class="logo-sesi"
      />
    </div>
  </div>
</div>
